import { Box } from "@mui/material";
import { useState } from "react";
import Group from "../../ComingSoon/cards/Group";
import Vitals from "../../ComingSoon/cards/Vitals";

const VitalMaster = () => {
  const [groupSelected, setGroupSelected] = useState(false);
  const [selectedGroupId, setSelectedGroupId] = useState(null);

  return (
    <Box sx={{ padding: "20px" }}>
      {groupSelected ? (
        <Vitals
          groupId={selectedGroupId}
          onBack={() => {
            setGroupSelected(false);
            setSelectedGroupId(null);
          }}
        />
      ) : (
        <Group
          onGroupClick={(id) => {
            setSelectedGroupId(id);
            setGroupSelected(true);
          }}
        />
      )}
    </Box>
  );
};

export default VitalMaster;
